'use client';
import {useEffect} from 'react';

export default function GlobalError({error,reset}:{error:Error&{digest?:string};reset:()=>void}){
  const chunk=/chunk|loading css|failed to fetch dynamically imported module/i.test(error?.message||'');
  useEffect(()=>{
    if(chunk&&sessionStorage.getItem('luai_chunk_retry')!=='1'){
      sessionStorage.setItem('luai_chunk_retry','1');
      location.reload();
    }
  },[error]);
  return <html lang="zh-CN"><body><main style={{minHeight:'70vh',display:'grid',placeContent:'center',textAlign:'center',padding:24,fontFamily:'system-ui'}}><h1>{chunk?'页面资源更新中':'页面暂时无法显示'}</h1><p>{chunk?'浏览器可能仍在使用旧版本文件，请重新加载页面。':'服务器未能完成本次请求，请稍后重试。'}</p><button onClick={()=>{sessionStorage.removeItem('luai_chunk_retry');reset();location.reload()}} style={{margin:'18px auto',padding:'11px 18px',border:0,borderRadius:9,background:'#7055e5',color:'#fff'}}>重新加载</button></main></body></html>
}
